'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('speechtype', {
        url: '/speechtype',
        template: '<speechtype></speechtype>'
    });
}



// WEBPACK FOOTER //
// ./client/app/speechtype/speechtype.routes.js